import React from "react";
import { useHistory } from "react-router-dom";
import "./FeatureCards.css";

/* ════════════════════════════════════════════════════════════════════════
   🔧 EDIT YOUR CARDS HERE
   For each card add TWO images + a link:
     • icon  →  the symbol/icon shown at the top
     • art   →  the decorative graphic shown faded at the bottom
     • link  →  internal route ("/symbols") or external URL ("https://…")

   1) Import your images at the top:
        import valuationsIcon from "../../../assets/images/home/valuations-icon.png";
        import valuationsArt  from "../../../assets/images/home/valuations-art.png";
   2) Reference them in the CARDS array below (replace the `null`s).
   ════════════════════════════════════════════════════════════════════════ */

// top icons (feature_icon4 & feature_icon5 not added yet → left null)
import icon1 from "../../../assets/images/feature_icon1.png";
import icon2 from "../../../assets/images/feature_icon2.png";
import icon3 from "../../../assets/images/feature_icon3.png";
import icon4 from "../../../assets/images/feature_icon4.png";
import icon5 from "../../../assets/images/feature_icon5.png";
import icon6 from "../../../assets/images/feature_icon6.png";
// bottom art graphics
import art1 from "../../../assets/images/feature1.png";
import art2 from "../../../assets/images/feature2.png";
import art3 from "../../../assets/images/feature3.png";
import art4 from "../../../assets/images/feature4.png";
import art5 from "../../../assets/images/feature5.png";
import art6 from "../../../assets/images/feature6.png";

const CARDS = [
  { l1: "Market",   l2: "Valuations", icon: icon1, art: art1, link: "/trading-dashboard/PSX" },
  { l1: "Realtime", l2: "Charting",   icon: icon2, art: art2, link: "/chart-view" },
  { l1: "Shariah",  l2: "Stocks",     icon: icon3, art: art3, link: "/symbols?filter=shariah" },
  { l1: "Trading",  l2: "Signals",    icon: icon4,  art: art4, link: "/technical-analysis" },
  { l1: "Free",     l2: "Workshop",   icon: icon5,  art: art5, link: "/about-online-trading" },
  { l1: "Market",   l2: "Overview",   icon: icon6, art: art6, link: "/market-overview" },
];

const FeatureCards = () => {
  const history = useHistory();

  const openLink = (link) => {
    if (!link) return;
    if (/^https?:\/\//i.test(link)) window.open(link, "_blank", "noopener");
    else history.push(link);
  };

  return (
    <section className="fc-section">
      <div className="fc-inner">
        {CARDS.map((c, i) => (
          <div
            key={i}
            className="fcard"
            role="link"
            tabIndex={0}
            onClick={() => openLink(c.link)}
            onKeyDown={(e) => { if (e.key === "Enter") openLink(c.link); }}
          >
            {c.icon && (
              <div className="fcard-icon">
                <img src={c.icon} alt={`${c.l1} ${c.l2}`} draggable="false" />
              </div>
            )}

            <div className="fcard-title">{c.l1}<br />{c.l2}</div>
            <span className="fcard-underline" />

            {c.art && (
              <img className="fcard-art" src={c.art} alt="" aria-hidden="true" draggable="false" />
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeatureCards;
